import debug from 'debug';

// Create the main app namespace
export const appDebug = debug('app');

// Create scanner namespace extended from app
export const scannerDebug = debug('app:scanner');

// You can add more namespaces as needed
// export const cameraDebug = debug('app:camera');
// export const apiDebug = debug('app:api');
